var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTern(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32801)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#F4C257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.72219 12.1157L4.06856 11.736V6.01031L5.12156 5.39831L5.77519 5.77744L4.72219 6.39V8.38013L7.38506 9.92812V10.6644L4.72219 9.117V12.1157ZM13.9219 10.9766V11.736L8.9955 14.5991L7.9425 13.9866V13.2272L8.9955 13.8392L10.7083 12.8441V9.74925L11.3417 9.38081V12.4762L13.9219 10.9766ZM15.1779 8.87288V8.7435L12.6354 10.2218V9.48487L15.1779 8.00719V5.28019L8.99437 1.6875L5.90344 3.48412L5.79206 3.54881L8.33456 5.0265L7.70119 5.39438L5.15869 3.91669L2.8125 5.28019V12.4656L5.90344 14.2622L6.01538 14.3269V11.3715L6.64875 11.7394V14.6953L8.9955 16.0583L15.1779 12.4656V8.87288ZM11.9745 7.50938L9.41513 8.99775V12.0926L8.9955 12.3362L8.67881 12.1523V9.17662L6.01538 7.62862V7.1415L6.33206 6.957L8.89256 8.44481L11.556 6.89794L11.9751 7.1415V7.50994L11.9745 7.50938ZM8.34188 3.52688L8.99494 3.14775L13.9213 6.01087V7.23431L13.2688 7.61344V6.38944L11.5549 5.39438L8.892 6.94181L8.25806 6.57394L10.9215 5.02594L8.34188 3.52688Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32801"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTern);
export default __webpack_public_path__ + "static/media/tern.e36882675b1f37ed42a4af843c10b9d7.svg";
export { ForwardRef as ReactComponent };